module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "img",
    attrs: {
      "id": "pic1"
    }
  }, [_c('img', {
    staticClass: "calibre6",
    attrs: {
      "alt": "",
      "id": "id-4922091315955511206",
      "src": "Images/img0001.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("IT WAS THE LAST SHOT. AS HE FIRED IT LARRY LEAPED TO ONE SIDE TO ESCAPE THE LION’S CLAWS.")])]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "Page_iii",
      "title": "iii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0